"use client";

import React from "react";
import { Phone, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Map() {
  const {
    ref: leftColRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="map" className="bg-background py-24 lg:py-32 relative overflow-hidden">
      <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px] pointer-events-none" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          
          <div ref={leftColRef} className={`lg:col-span-12 space-y-8 transition-all duration-1000 ease-out ${isLeftVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl font-extrabold text-foreground uppercase tracking-tight">
                Ready to Build <span className="text-primary">Something Solid?</span>
              </h2>
              <p className="text-muted-foreground text-lg leading-relaxed">
                Serving Central and Northern Indiana with premium concrete solutions. Contact us today to discuss your next residential or commercial project.
              </p>
            </div>

            <div className="relative w-full overflow-hidden border border-border/30 bg-muted/20 shadow-2xl">
              <AspectRatio ratio={4 / 3}>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d392562.2639376126!2d-86.5456667!3d39.7797845!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x886b50ffa7796a03%3A0xd68e9df640b9ea7c!2sIndianapolis%2C%20IN!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus" width="100%" height="100%" style={{
                border: 0,
                filter: 'grayscale(100%) contrast(1.2) opacity(0.8)'
              }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Service Area Map" />
                <div className="absolute inset-0 pointer-events-none ring-1 ring-inset ring-white/10" />
              </AspectRatio>
              <div className="absolute bottom-4 left-4 right-4 bg-background/90 backdrop-blur-md p-4 border border-border/50 flex items-center gap-3">
                <div className="bg-primary/20 p-2 rounded-full">
                  <MapPin className="size-5 text-primary" />
                </div>
                <div>
                  <p className="text-sm font-bold text-foreground">Service Area</p>
                  <p className="text-xs text-muted-foreground">Central & Northern Indiana</p>
                </div>
              </div>
            </div>

            <Button asChild size="lg" className="w-full py-8 text-lg font-bold tracking-widest shadow-xl hover:shadow-primary/20 transition-all group">
              <Link to="tel:317-709-9540">call to schedule a quote</Link>
            </Button>
          </div>

        </div>
      </div>
    </section>;
}